<div class="feature-tools-container">
	<button title="{{LOCALIZATION.zoomIn}}" 
		(click)="zoomToFeature()" 
		class="btn btn-xs">
			{{LOCALIZATION.zoomIn}}
	</button>
</div>
